const insuanceMatserRouteList = {
  addOrEdit:"add-or-edit",
  insuranceType: "insurance-type",
  insurancePlanMasters: "insurance-plan-masters",
  insurancePriceMaster:"insurance-price-masters",
  insurance:"insurance",
  PriceRateEdit: "price-rate-edit",
  insuranceDiscount:"insurance-discount",
  networkMaster: "network-master",
};

export default insuanceMatserRouteList